import React from 'react';
import {Table} from '@/web-components';
import {useIntl} from 'react-intl';
import {hasFeatureFlag} from '../../../shared/util/FeatureUtil';
import {TimeRegistrationReportTooltips as Tooltips} from './TimeRegistrationReportTooltips';

export const getBaseLevelTableHeader = (columns, customFieldDefinitions = []) => {
	const {formatMessage} = useIntl();
	const hasFinancialCategoriesUpdate = hasFeatureFlag('financial_categories_update');

	return (
		<Table.Header>
			<Table.HeaderColumn usePadding flex={1} align="left" visible={true} width="MEDIUM">
				<Table.HeaderColumn.Title>{formatMessage({id: 'common.project'})}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
			<Table.HeaderColumn usePadding align="left" visible={true} width="MEDIUM">
				<Table.HeaderColumn.Title>{formatMessage({id: 'common.task'})}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
			<Table.HeaderColumn align="left" usePadding visible={columns['timeReg.task.phase.info']} width="MEDIUM">
				<Table.HeaderColumn.Title>{formatMessage({id: 'common.phase'})}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
			<Table.HeaderColumn align="left" usePadding visible={columns['timeReg.task.sprint.info']} width="MEDIUM">
				<Table.HeaderColumn.Title>{formatMessage({id: 'common.sprint'})}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
			<Table.HeaderColumn align="right" usePadding visible={true} width="SMALL">
				<Tooltips.ActualHoursTooltip>
					<Table.HeaderColumn.Title>
						{formatMessage({id: hasFinancialCategoriesUpdate ? 'common.actual_hours' : 'common.reported'})}
					</Table.HeaderColumn.Title>
				</Tooltips.ActualHoursTooltip>
			</Table.HeaderColumn>
			<Table.HeaderColumn align="right" usePadding visible={columns['actuals.timeReg.billableRegistered']} width="MEDIUM">
				<Tooltips.ActualBillableHoursTooltip>
					<Table.HeaderColumn.Title>
						{formatMessage({
							id: hasFinancialCategoriesUpdate ? 'common.actual_billable_hours' : 'common.billable_time',
						})}
					</Table.HeaderColumn.Title>
				</Tooltips.ActualBillableHoursTooltip>
			</Table.HeaderColumn>
			<Table.HeaderColumn
				align="right"
				usePadding
				visible={columns['actuals.timeReg.nonBillableRegistered']}
				width="MEDIUM"
			>
				<Tooltips.ActualNonBillableHoursTooltip>
					<Table.HeaderColumn.Title>
						{formatMessage({
							id: hasFinancialCategoriesUpdate ? 'common.actual_non_billable_hours' : 'common.non_billable_time',
						})}
					</Table.HeaderColumn.Title>
				</Tooltips.ActualNonBillableHoursTooltip>
			</Table.HeaderColumn>
			<Table.HeaderColumn align="left" usePadding visible={columns['timeReg.notes']} width="LARGE">
				<Table.HeaderColumn.Title>{formatMessage({id: 'common.notes'})}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
			<Table.HeaderColumn align="left" usePadding visible={columns['timeReg.date']} width="SMALL">
				<Table.HeaderColumn.Title>{formatMessage({id: 'common.dates'})}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
			<Table.HeaderColumn align="left" usePadding visible={true} width="MEDIUM">
				<Table.HeaderColumn.Title>{formatMessage({id: 'common.person'})}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
			<Table.HeaderColumn
				align="left"
				usePadding
				visible={columns['timeReg.role.info'] || columns['timeReg.person.role.info']}
				width="MEDIUM"
			>
				<Table.HeaderColumn.Title>{formatMessage({id: 'common.role'})}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
			<Table.HeaderColumn align="left" usePadding visible={columns['timeReg.person.department.info']} width="MEDIUM">
				<Table.HeaderColumn.Title>{formatMessage({id: 'common.department'})}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
			<Table.HeaderColumn align="left" usePadding visible={columns['timeReg.client.info']} width="MEDIUM">
				<Table.HeaderColumn.Title>{formatMessage({id: 'common.client'})}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
			<Table.HeaderColumn align="left" usePadding visible={columns['timeReg.billable']} width="MEDIUM">
				<Table.HeaderColumn.Title>{formatMessage({id: 'common.is_billable'})}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
			<Table.HeaderColumn align="right" usePadding visible={columns['actuals.timeReg.price']} width="MEDIUM">
				<Tooltips.ActualBillableValueOfServiceTooltip>
					<Table.HeaderColumn.Title>
						{formatMessage({
							id: hasFinancialCategoriesUpdate
								? 'common.actual_billable_value_of_service'
								: 'common.actual_revenue',
						})}
					</Table.HeaderColumn.Title>
				</Tooltips.ActualBillableValueOfServiceTooltip>
			</Table.HeaderColumn>
			<Table.HeaderColumn align="right" usePadding visible={columns['actuals.timeReg.cost']} width="MEDIUM">
				<Tooltips.ActualCostTooltip size="l">
					<Table.HeaderColumn.Title>{formatMessage({id: 'common.actual_cost'})}</Table.HeaderColumn.Title>
				</Tooltips.ActualCostTooltip>
			</Table.HeaderColumn>
			<Table.HeaderColumn align="left" usePadding visible={columns['timeReg.invoiced']} width="SMALL">
				<Table.HeaderColumn.Title>{formatMessage({id: 'common.invoiced'})}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
			<Table.HeaderColumn align="left" usePadding visible={columns['timeReg.approvalStatus']} width="SMALL">
				<Table.HeaderColumn.Title>{formatMessage({id: 'common.approved'})}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
			{customFieldDefinitions.map(({displayName, key}) => {
				return (
					<Table.HeaderColumn
						align="center"
						usePadding
						visible={columns['company.reportCustomFieldDefinitions.' + key]}
						width="MEDIUM"
					>
						<Table.HeaderColumn.Title>{displayName}</Table.HeaderColumn.Title>
					</Table.HeaderColumn>
				);
			})}
		</Table.Header>
	);
};
